<section class="text-info__section">
  <div class="text-info__container">
    <div class="text-info__text">
      @if (title) {
        <h2 class="text-info__text__title" [bindHTML]="title"></h2>
      }
      @if (description) {
        <div
          class="text-info__text__description"
          [bindHTML]="description"
        ></div>
      }
    </div>
  </div>
</section>
